import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function ApplianceOnTimeDetailContainer({ value, deviceId, multipleDaysLogs, time}) {

  return (
    <DetailContainer
      name={`Appliance On Time`}
      value={`${value}`}
      time={time}
      showDay={multipleDaysLogs?.length > 1 ? true : false}
      color={"#FDECEC"}
      borderColor={"#EF4444"}
      image={images.calendar}
    />
  )
}

export default ApplianceOnTimeDetailContainer